import { Accordion, Divider, Flex, Text, type ConnectionResourceItemProps, ConnectionItem } from "@wayflyer/flyui";
import type React from "react";
import { useIntl } from "react-intl";

interface PlatformsAccordionProps {
  header: string | React.ReactNode;
  platformItems: ConnectionResourceItemProps[];
}

export const PlatformsAccordion = ({ header, platformItems }: PlatformsAccordionProps) => {
  const intl = useIntl();

  return (
    <Flex direction="column" gap="4">
      <Divider />
      <Accordion
        items={[
          {
            header,
            body:
              platformItems.length > 0 ? (
                <Flex direction="column" gap="2">
                  {platformItems.map((item, idx) => {
                    return (
                      <ConnectionItem
                        key={idx}
                        label={item.label}
                        logo={item.icon}
                        badgeStatus={item.status !== "incomplete" ? item.status : undefined}
                        badgeText={item.statusText}
                      />
                    );
                  })}
                </Flex>
              ) : (
                <Text>
                  {intl.formatMessage({
                    id: "funding-application: connected platform accordion empty state",
                    defaultMessage: "No connected platforms",
                  })}
                </Text>
              ),
          },
        ]}
        showFinalDivider={false}
      />
    </Flex>
  );
};
